import PropTypes from 'prop-types';

export default PropTypes.oneOf(['topleft', 'topright', 'bottomleft', 'bottomright']);


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-leaflet/es/propTypes/controlPosition.js
// module id = 58
// module chunks = 0